import { withInstall } from '../../../utils/with-install'
import Rectangle from './Rectangle.vue'

export const ElAmapRectangle = withInstall(Rectangle)
export default ElAmapRectangle
